import React, { useState, useEffect } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions, Button,
    FormControl, InputLabel, Select, MenuItem, CircularProgress,
    Box, Stack, Typography,
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';

const qualityOptions = [
    { value: 10, label: 'Muito Baixa (10%)' },
    { value: 15, label: 'Baixa (15%)' },
    { value: 50, label: 'Média (50%)' },
    { value: 70, label: 'Boa (70%)' },
    { value: 90, label: 'Alta (90%)' }, 
];

export default function ModalUploadFotos({ open, onClose, onSave, isLoading }) {
    const [file, setFile] = useState(null);
    const [preview, setPreview] = useState(null);
    const [quality, setQuality] = useState(70); 

    useEffect(() => {

        if (!file) {
            setPreview(null);
            return;
        }

        const objectUrl = URL.createObjectURL(file);
        setPreview(objectUrl);

        return () => URL.revokeObjectURL(objectUrl);
    }, [file]);


    const handleFileChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            setFile(e.target.files[0]);
        }
    };

    const handleUpload = async () => {
        if (!file) {
            alert("Por favor, selecione uma imagem primeiro!");
            return;
        }

        onSave({ file, quality });
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>
                <Stack direction="row" spacing={1.5} alignItems="center">
                    <Typography variant="h6" component="div" fontWeight="bold">
                        ☁️ Upload de Imagem
                    </Typography>
                </Stack>
            </DialogTitle>

            <DialogContent dividers>
                <Stack spacing={3} sx={{ mt: 1 }}>

                    {/* Componente para o Preview da Imagem */}
                    {preview && (
                        <Box
                            sx={{
                                width: '100%',
                                height: 250,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                border: '2px dashed',
                                borderColor: 'grey.300',
                                borderRadius: 2,
                                overflow: 'hidden'
                            }}
                        >
                            <img
                                src={preview}
                                alt="Preview da imagem selecionada"
                                style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
                            />
                        </Box>
                    )}

                    {/* Botão customizado para selecionar o arquivo */}
                    <Button
                        variant="outlined"
                        component="label"
                        fullWidth
                    >
                        {file ? `Arquivo: ${file.name}` : "Selecionar Imagem"}
                        <input
                            type="file"
                            hidden
                            accept="image/png, image/jpeg"
                            onChange={handleFileChange}
                        />
                    </Button>

                    {/* Seletor de Qualidade */}
                    <FormControl fullWidth>
                        <InputLabel id="quality-select-label">Qualidade da Compressão</InputLabel>
                        <Select
                            labelId="quality-select-label"
                            value={quality}
                            label="Qualidade da Compressão"
                            onChange={(e) => setQuality(e.target.value)}
                        >
                            {qualityOptions.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Stack>
            </DialogContent>

            <DialogActions sx={{ p: '16px 24px' }}>
                <Button onClick={onClose} disabled={isLoading === 'save'} color="secondary">
                    Cancelar
                </Button>
                <Button
                    onClick={handleUpload}
                    variant="outlined"
                    disabled={!file || isLoading === 'save'}
                    startIcon={isLoading === 'save' ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />}
                >
                    {isLoading === 'save' ? 'Enviando...' : 'Enviar Foto'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}